import { defineStore } from 'pinia';
import { ref, readonly, computed } from 'vue';

export const useUserState = defineStore('userState', () => {
  // State — default to authenticated in dev mode so WS subscriptions activate
  const authenticated = ref(import.meta.env.DEV);
  const account = ref('');
  const isInitialized = ref(import.meta.env.DEV);

  // Computed - only use public API when explicitly initialized AND not authenticated
  // This ensures other UIs that don't set the store will use private API
  const usePublicApi = computed(() => isInitialized.value && !authenticated.value);

  // Actions
  const setUserState = (auth: boolean, acct: string) => {
    authenticated.value = auth;
    account.value = acct;
    isInitialized.value = true;
  };

  return {
    // State (readonly)
    authenticated: readonly(authenticated),
    account: readonly(account),
    isInitialized: readonly(isInitialized),

    // Computed
    usePublicApi,

    // Actions
    setUserState,
  };
});
